import { useEffect } from "react";

// Client-side meta sync for SPA navigation. Crawler metadata comes from the
// prerendered HTML written by scripts/prerender.js, not from this component.
export const Meta = ({ route }) => {
  useEffect(() => {
    if (!route) return;
    document.title = route.title;
    const d = document.querySelector('meta[name="description"]');
    if (d) d.setAttribute("content", route.description);
  }, [route]);
  return null;
};
